import { Capacitor } from "@capacitor/core";
import { Share } from "@capacitor/share";
import { Filesystem, Directory } from "@capacitor/filesystem";

export async function shareBlobAsFile(
  blob: Blob,
  filename: string,
  title?: string,
  text?: string
) {
  // Web: use navigator.share if supports files
  if (!Capacitor.isNativePlatform()) {
    const file = new File([blob], filename, { type: blob.type });
    // @ts-ignore
    if (navigator.canShare?.({ files: [file] }) && navigator.share) {
      // @ts-ignore
      await navigator.share({ title, text, files: [file] });
      return;
    }
    // fallback download
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(url);
    return;
  }

  // Native: write to Filesystem and share the file URI
  const base64 = await blobToBase64(blob);

  const write = await Filesystem.writeFile({
    path: filename,
    data: base64,
    directory: Directory.Cache,
  });

  await Share.share({
    title,
    text,
    url: write.uri,
    dialogTitle: title,
  });
}

function blobToBase64(blob: Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      const result = reader.result?.toString() || "";
      // result = "data:image/png;base64,...."
      resolve(result.split(",")[1] || "");
    };
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}
